import useProjectGraphQl from "../store/project-graphql";

export default useProjectGraphQl;